import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, ViewChild, inject, input, output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { FontIconComponent } from '@camelot/icons';
import { BottomSheetTemplateGenericComponent, BottomSheetTemplateGenericParams } from '@camelot/menu';
import { ButtonComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { SearchHistoryDisplayerComponent } from './search-history-displayer/search-history-displayer.component';

@Component({
  selector: 'cam-search-displayer',
  templateUrl: './search-displayer.component.html',
  styleUrls: ['./search-displayer.component.scss'],
  imports: [CommonModule, NgTemplateOutlet, ButtonComponent, FontIconComponent, SearchHistoryDisplayerComponent],
})
export class SearchDisplayerComponent extends CamBaseComponent {
  container = input<'button' | 'link'>('button');

  placeholder = input('');

  searchHistory = input<{
    type: string;
  }>();

  valueCompleted = output<any>();

  private _bottomSheet = inject(MatBottomSheet);

  @ViewChild('searchTemplate', { read: TemplateRef })
  searchTemplate!: TemplateRef<void>;

  get mobileDetection() {
    return this.breakpoints.isMobile;
  }

  public openDialog() {
    if (!this.searchHistory()?.type) {
      return;
    }
    this._bottomSheet.open<BottomSheetTemplateGenericComponent, BottomSheetTemplateGenericParams>(
      BottomSheetTemplateGenericComponent,
      {
        data: {
          template: this.searchTemplate,
          context: {
            options: { isDropDown: false },
          },
        },
      }
    );
  }

  public action(result: any) {
    this._bottomSheet.dismiss();
    if (result) {
      this.valueCompleted.emit(result);
    }
  }
}
